import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Observable, combineLatest } from "rxjs";
import { FormControl } from "@angular/forms";
import { finalize, map, startWith, tap, shareReplay } from "rxjs/operators";
import { IWorkOrder } from "../models/IWorkOrder";
import { WorkOrderService } from "../work-order.service";
import { ISelectableWorkOrder } from "../../projects/project-manage/models/ISelectableWorkOrder";

@Component({
  selector: "app-choose-workorder",
  templateUrl: "./choose-workorder.component.html",
  styleUrls: ["./choose-workorder.component.scss"],
})
export class ChooseWorkOrderComponent implements OnInit {
  @Input() selectedWorkorders: IWorkOrder[];

  private loadingSubject = new BehaviorSubject<boolean>(false);
  private availableWorkOrders: ISelectableWorkOrder[] = [];

  loading$ = this.loadingSubject.asObservable();
  keywordFilter = new FormControl("");
  workorders$: Observable<ISelectableWorkOrder[]>;

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: WorkOrderService
  ) { }

  ngOnInit() {
    this.loadingSubject.next(true);

    const allWorkOrders$ = this.workOrderService.getWorkOrders().pipe(
      finalize(() => this.loadingSubject.next(false)),
      map((workorders) => {
        return workorders
          .map((workorder) => {
            const selectedWorkOrder = this.selectedWorkorders.find(
              (p) => workorder.id === p.id
            );
            const isSelected = !!selectedWorkOrder;
            const canBeToggled = !(
              isSelected &&
              selectedWorkOrder.timeEntries &&
              selectedWorkOrder.timeEntries.length > 0
            );
            const selectableWorkOrder: ISelectableWorkOrder = Object.assign(
              { selected: isSelected, canBeToggled },
              workorder
            );
            return selectableWorkOrder;
          });
          //.sort(this.sortBySelectedThenName.bind(this));
      }),
      shareReplay(1)
    );
    allWorkOrders$.subscribe((workorders) => {
      this.availableWorkOrders = workorders;
    });
    const keywordFilter$ = this.keywordFilter.valueChanges.pipe(startWith(""));

    this.workorders$ = combineLatest([allWorkOrders$, keywordFilter$]).pipe(
      map(([workOrders, keyword]) => {
        return workOrders.filter((workOrder) => this.search(workOrder, keyword));
      })
    );
    console.log(allWorkOrders$);
  }
  toggle(workOrder: ISelectableWorkOrder) {
    if (workOrder.canBeToggled) {
      workOrder.selected = !workOrder.selected;
    }
  }
  selectAll(selecting: boolean) {
    this.workorders$.forEach((e) => {
      e.map(w => w.selected = selecting);
    })
  }
  close() {
    this.activeModal.close(this.availableWorkOrders.filter((w) => w.selected));
  }
  dismiss() {
    this.activeModal.dismiss();
  }
  private search(workOrder: ISelectableWorkOrder, text: string) {
    const keyword = text.toLowerCase();
    return workOrder.name.toLowerCase().includes(keyword);
  }
  private sortBySelectedThenName(a: ISelectableWorkOrder, b: ISelectableWorkOrder) {
    if (a.selected && !b.selected) {
      return -1;
    } else if (!a.selected && b.selected) {
      return 1;
    }
    return this.workOrderService.sortByName(a, b);
  }
}
